import { Vec2 } from "utils/math/vec2";
import { Webgl2dRenderer } from "../../../webgl2d-renderer";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { CanvasResizeSelectionComponent } from "./canvas-resize-selection-component";
import { CanvasResizeUnitComponent } from "./canvas-resize-unit-component";

export class CanvasResizeSelectionBottomRightComponent extends Webgl2Component {
  private _mouseDownPosition = Vec2.zero();
  private _prevTransform: Webgl2Component["transform"];

  constructor(
    private readonly _renderer: Webgl2dRenderer,
    private readonly _canvasResizeSelectionComponent: CanvasResizeSelectionComponent,
  ) {
    super();

    const bottomUnit = new CanvasResizeUnitComponent(new Vec2(18, 4));
    bottomUnit.style.top = "100%";
    bottomUnit.style.translateY = "-100%";
    bottomUnit.style.pointerEvents = "none";
    this.appendChild(bottomUnit);

    const rightUnit = new CanvasResizeUnitComponent(new Vec2(4, 18));
    rightUnit.style.left = "100%";
    rightUnit.style.translateX = "-100%";
    rightUnit.style.pointerEvents = "none";
    this.appendChild(rightUnit);

    this.transform.setSize(18, 18);
  }

  public onMouseDown(e: MouseEvent | TouchEvent) {
    this._mouseDownPosition = this._renderer.camera.getGlobalMousePixelPosition(e);
    this._prevTransform = this._canvasResizeSelectionComponent.transform.clone();
  }

  public onMouseMove(e: MouseEvent | TouchEvent) {
    const currentMousePos = this._renderer.camera.getGlobalMousePixelPosition(e);
    const mouseDiff = currentMousePos.clone().sub(this._mouseDownPosition);
    const newSize = this._prevTransform.size.clone().add(mouseDiff);

    this._renderer.setCanvasSize(newSize);
    this._canvasResizeSelectionComponent.copyComponentTransform(this._renderer.chessGridComponent);
    this._renderer.render();
  }

  public getRenderData() {
    const material = Webgl2.materials.transparent;
    return { material };
  }
}

export default CanvasResizeSelectionBottomRightComponent;
